import { dxtToLocalServerTime } from "@dexteel/mesf-core";
import { ColDef, ColGroupDef, ICellRendererParams } from "ag-grid-enterprise";
import { isNumber } from "lodash-es";
import { WireAddition } from "../../../../models/eaf.models";
import { EditAndDeleteButtons } from "../../components/EditAndDeleteButtons";
import { ManualAutoButton } from "../../components/ManualAutoButton";

type Props = {
	deleteWireAddition: (wireAdditionId: number) => void;
	editWireAddition: (wireAdditionId: number) => void;
};

export const useTableData = ({
	deleteWireAddition,
	editWireAddition,
}: Props) => {
	const columns: ColGroupDef[] = [
		{
			headerName: "Wire Additions",
			headerStyle: {
				fontSize: "0.9rem",
			},
			children: [
				{
					field: "IsManual",
					headerName: " ",
					flex: 1,
					minWidth: 50,
					maxWidth: 50,
					cellRenderer: ManualAutoButton,
					cellRendererParams: (params: ICellRendererParams) => ({
						isManual: (params.data as WireAddition).IsManual,
					}),
				},
				{
					field: "Line",
					headerName: "Line",
					flex: 1,
					minWidth: 52,
					maxWidth: 52,
				},
				{
					field: "End",
					headerName: "Time",
					flex: 1,
					minWidth: 61,
					valueGetter: (params: any) => {
						if (params.data.End) {
							return dxtToLocalServerTime(
								(params.data as WireAddition).End,
								"HH:mm",
							);
						}
					},
				},
				{
					field: "MaterialName",
					headerName: "Material",
					flex: 1,
					minWidth: 78,
				},
				{
					field: "RequestedValue",
					headerName: "Requested [ft]",
					wrapHeaderText: true,
					flex: 1,
					minWidth: 90,
					cellStyle: {
						textAlign: "right",
					},
				},
				{
					field: "InjectedValue",
					headerName: "Injected [ft]",
					wrapHeaderText: true,
					flex: 1,
					minWidth: 90,
					cellStyle: {
						textAlign: "right",
					},
					valueGetter: (params: any) => {
						if (isNumber(params.data.InjectedValue)) {
							const value = (params.data as WireAddition).InjectedValue;
							return value % 1 === 0 ? value : value.toFixed(2);
						}
					},
				},
				{
					field: "actions",
					headerName: " ",
					flex: 1,
					minWidth: 80,
					maxWidth: 80,
					cellRenderer: EditAndDeleteButtons,
					cellRendererParams: (params: ICellRendererParams) => ({
						deleteItem: deleteWireAddition,
						edit: editWireAddition,
						id: (params.data as WireAddition).WireAdditionId,
					}),
				},
			],
		},
	];

	const defaultColDef: ColDef = {
		filter: false,
		floatingFilter: false,
		sortable: false,
		resizable: false,
		editable: false,
	};

	return { columns, defaultColDef };
};
